import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin, Lock } from "lucide-react";
import { STORE } from "@/lib/store";

export const Footer = () => {
  return (
    <footer className="bg-[#0B0A09] text-zinc-300">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <span className="inline-flex items-center rounded-lg bg-white px-3 py-2">
              <img src={STORE.logo} alt="Knoble Rides Enterprises" className="h-14 w-auto" />
            </span>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-400">
              {STORE.motto}. Quality bicycles for every rider in Lagos, Nigeria — every purchase includes a free
              helmet & bike pump.
            </p>
            <a
              href={STORE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-medium text-zinc-200 transition-colors hover:border-[#8C5A32] hover:text-white"
            >
              <Instagram className="h-4 w-4" /> {STORE.instagram}
            </a>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Quick Links</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/bikes" className="text-zinc-400 hover:text-[#c98a5a]">Shop Bikes</Link></li>
              <li><Link to="/bikes" className="text-zinc-400 hover:text-[#c98a5a]">Shop by Category</Link></li>
              <li><Link to="/gallery" className="text-zinc-400 hover:text-[#c98a5a]">Gallery</Link></li>
              <li><Link to="/about" className="text-zinc-400 hover:text-[#c98a5a]">About Us</Link></li>
              <li><Link to="/contact" className="text-zinc-400 hover:text-[#c98a5a]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Visit Us</h4>
            <ul className="mt-4 space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#8C5A32]" />
                <span className="text-zinc-400">{STORE.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-[#8C5A32]" />
                <a href={STORE.phoneTel} data-testid="footer-phone-link" className="text-zinc-400 hover:text-white">
                  {STORE.phoneDisplay}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Categories</h4>
            <ul className="mt-4 grid grid-cols-1 gap-3 text-sm">
              <li><Link to="/bikes?category=electric-bikes" className="text-zinc-400 hover:text-[#c98a5a]">Electric Bikes</Link></li>
              <li><Link to="/bikes?category=mountain-bikes" className="text-zinc-400 hover:text-[#c98a5a]">Mountain Bikes</Link></li>
              <li><Link to="/bikes?category=road-bikes" className="text-zinc-400 hover:text-[#c98a5a]">Road Bikes</Link></li>
              <li><Link to="/bikes?category=bmx-bikes" className="text-zinc-400 hover:text-[#c98a5a]">BMX Bikes</Link></li>
              <li><Link to="/bikes?category=kids-bikes" className="text-zinc-400 hover:text-[#c98a5a]">Kids Bikes</Link></li>
              <li><Link to="/bikes?category=accessories" className="text-zinc-400 hover:text-[#c98a5a]">Accessories</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-zinc-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {STORE.name}. All rights reserved.</p>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-1.5 text-zinc-600 transition-colors hover:text-zinc-300"
          >
            <Lock className="h-3.5 w-3.5" /> Staff Login
          </Link>
        </div>
      </div>
    </footer>
  );
};
